import { ResultsKeyType } from '@data/types';
import classNames from 'classnames';
import React from 'react';

interface Props extends ResultsKeyType {}

const ResultsKey: React.FC<Props> = ({ className, region }) => {
  return (
    <div className={classNames('text-white', className)}>
      <dl className="flex flex-row items-center gap-2 mb-4">
        <dt>
          <i className="px-2 bg-purple rounded-tr-lg rounded-bl-lg"></i>
        </dt>
        <dd className="text-sm font-lightNormal flex items-center">
          Your overall score
        </dd>
      </dl>
      <dl className="flex flex-row items-center gap-2 mb-4">
        <dt>
          <i className="px-2 bg-blue-light rounded-tr-lg rounded-bl-lg"></i>
        </dt>
        <dd className="text-sm font-lightNormal flex items-center">
          Global (average)
        </dd>
      </dl>
      <dl className="flex flex-row items-center gap-2 mb-4">
        <dt>
          <i className="px-2 bg-green rounded-tr-lg rounded-bl-lg"></i>
        </dt>
        <dd className="text-sm font-lightNormal flex items-center">
          Regional (average): {region}
        </dd>
      </dl>
      <dl className="flex flex-row items-center gap-2 mb-4">
        <dt>
          <i className="px-2 bg-yellow rounded-tr-lg rounded-bl-lg"></i>
        </dt>
        <dd className="text-sm font-lightNormal flex items-center">
          Market Leaders (average)
        </dd>
      </dl>
    </div>
  );
};

export default ResultsKey;
